module.exports = __webpack_public_path__ + "static/1135940064.a984a819.jpg";